import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from "@mui/material/Typography";

import {
  getSessionCategory,
  formatSessionDate,
  formatSessionTime,
  formatSessionLocation,
  formatSessionVirtualLink, getSessionLink
} from '../../helpers/sessions';
import {formatPatientName, formatPatientPhone} from '../../helpers/patients';
import {formatProviderName} from '../../helpers/providers';
import {formatCaseName} from '../../helpers/cases';
// import SessionBookmark from './SessionBookmark';
import BetaFeature from '../common/BetaFeature';
import SessionStatus from './SessionStatus';
import SessionActions from './SessionActions';
import config from "../../config/config";

const SessionTableRow = props => {
  const navigate = useNavigate();
  const {data: s, isPatient, afterSave} = props;
  const url = getSessionLink(s.id);
  const viewSessionDetail = () => navigate(url);
  const preventParentEvent = (event) => {
    event.stopPropagation();
  };
  return (
    <TableRow
      key={s.id}
      sx={{
        cursor: 'pointer',
        '&:hover': {background: 'var(--hover-fill)'}
    }}
      onClick={() => viewSessionDetail()}
    >
      {/* <TableCell> */}
        {/* <SessionBookmark session={s} size='small'/> */}
      {/* </TableCell> */}
      <TableCell>
        <SessionStatus session={s} />
      </TableCell>
      {
        props.showAllProviders 
        && <TableCell>
          {formatProviderName(s.provider)}
        </TableCell>
      }
      <TableCell>
        <Typography variant='small500Inter'>
          {formatSessionDate(s, 'M/D/YYYY')}, {formatSessionTime(s)}
        </Typography>
      </TableCell>
      <TableCell>
        {
          isPatient
          ? formatProviderName(s.provider)
          : <Button  sx={{color: config().colors.text, textAlign: 'start'}} onClick={(event) => {
            preventParentEvent(event);
            navigate(`/providers/patients/view/${s.patient.id}`);
          }}>
              <Typography variant='small500Inter'>
                {formatPatientName(s.patient)}
              </Typography>
          </Button>
        }
      </TableCell>
      <BetaFeature hideTag={true}>
        <TableCell>
          <Typography variant='small500Inter'>
              {formatCaseName(s.case)}
          </Typography>
        </TableCell>
      </BetaFeature>
      <TableCell>
        {getSessionCategory(s)}
      </TableCell>
      {
        isPatient
        ? null
        : <TableCell>
          <Box onClick={preventParentEvent}>
            {formatPatientPhone(s.patient, {returnLinkText: true})}
          </Box>
        </TableCell>
      }
      <TableCell>
        <Box sx={{width: 'fit-content'}} onClick={preventParentEvent}>
          {
            s.location === 'VIRTUAL'
            ? formatSessionVirtualLink(s, {returnLinkText: true})
            : formatSessionLocation(s, {returnLinkText: true})
          }
        </Box>
      </TableCell>
      <TableCell>
        <Stack direction='row' justifyContent='end'>
          <Stack
            direction='row'
            spacing={2}
            onClick={preventParentEvent}
            sx={{ 'button, a': { minWidth: '162.5px', width: 'fit-content'} }}
          >
            <SessionActions
              session={s}
              isPatient={isPatient}
              variant='card'
              onSave={afterSave}
            />
          </Stack>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

SessionTableRow.propTypes = {
  data: PropTypes.object,
  buttons: PropTypes.arrayOf(PropTypes.element),
  isPatient: PropTypes.bool,
  afterSave: PropTypes.func,
};

export default SessionTableRow;
